import { render, staticRenderFns } from "./ColorDoc.vue?vue&type=template&id=03293a3b&scoped=true&"
import script from "./ColorDoc.vue?vue&type=script&lang=js&"
export * from "./ColorDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03293a3b",
  null
  
)

export default component.exports